// Lightweight guest-mode passphrase handling. For signed-in users the
// backend bcrypts and stores the hash; for guests the note never leaves
// their browser so we hash with SHA-256 + a random per-note salt and
// stash both locally. Still prevents the content from being read without
// the passphrase if the user leaves the device unlocked for a moment.

async function sha256Hex(input) {
  const enc = new TextEncoder();
  const buf = await crypto.subtle.digest("SHA-256", enc.encode(input));
  return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, "0")).join("");
}

function randomSaltHex(len = 16) {
  const bytes = new Uint8Array(len);
  crypto.getRandomValues(bytes);
  return Array.from(bytes).map((b) => b.toString(16).padStart(2, "0")).join("");
}

/** Compute a stable guest-mode hash from passphrase + salt. */
export async function hashGuestPassphrase(passphrase, salt) {
  return sha256Hex(`${salt}:${passphrase}`);
}

/** Return a {salt, hash} pair for a brand-new lock. */
export async function newGuestLock(passphrase) {
  const salt = randomSaltHex();
  const hash = await hashGuestPassphrase(passphrase, salt);
  return { salt, hash };
}

/** Verify a passphrase against a stored guest lock. */
export async function verifyGuestLock(passphrase, salt, expectedHash) {
  if (!salt || !expectedHash) return false;
  const actual = await hashGuestPassphrase(passphrase, salt);
  return actual === expectedHash;
}
